import { createLog, LogSeverity } from '../../../utils/createLog.js';
import { registerServiceProvider } from '../ServiceProviderRegistry.js';
import { Services } from './Services.js';
import { servicesProviderOriginatorDataSchema } from './ServicesProviderOriginatorData.js';
import { PayableServicesProvider } from './ServicesProviderPayable.js';

class ServicesProviderOriginator extends PayableServicesProvider {
    constructor(data) {
        super(data);
        this.validateData(data);
    }
    validateData(data) {
        const result = servicesProviderOriginatorDataSchema.safeParse(data);
        if (!result.success) {
            createLog('ServicesProviderOriginator.validation', `ServicesProviderOriginator data validation failed for svp id ${data.id}: ${result.error.message}`, LogSeverity.ERROR, {
                service: Services.ORIGINATOR,
                errors: result.error.errors,
            });
            // TODO: change to throw error once db is cleaned up
            return data;
        }
        return result.data;
    }
}
// Register this subclass with ServicesProvider
registerServiceProvider(Services.ORIGINATOR, ServicesProviderOriginator);

export { ServicesProviderOriginator };
//# sourceMappingURL=ServicesProviderOriginator.js.map
